module.exports = function() {
  return new Worker(__webpack_public_path__ + "d7d644fb583340563458.worker.js");
};